import { api } from "@/lib/http.ts";
import type { PasswordlessOptionsResp } from "@/types/passwordlessAuth.ts";
import { queryOptions } from "@tanstack/react-query";

/**
 * Which passwordless doors the sign-in page may offer: phone, and WhatsApp.
 *
 * The page renders outside the Statsig provider, so the gate is read on the
 * server and fetched. A failure answers "no": the frontend and the backend
 * deploy separately, so this page can be live against an API that has never
 * heard of the endpoint, and the door stays shut until the half that enforces
 * the gate is actually there.
 */
export const passwordlessOptionsQuery = queryOptions({
  queryKey: ["passwordless", "options"] as const,
  queryFn: async ({ signal }) => {
    const res = await api.get<PasswordlessOptionsResp>("/api/p/auth/passwordless/options", {
      signal,
    });
    return res.data;
  },
  retry: false,
  // Short rather than infinite: this is a rollout control, and a sign-in page
  // left open on a desk should notice the door opening or closing rather than
  // holding the answer it got when the tab was first loaded.
  staleTime: 60_000,
});
